import { CheckCircle2, Circle, AlertTriangle } from "lucide-react";
import type { TrackingEvent } from "./types";

const fmt = (iso: string) =>
  new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

export function StatusTimeline({ events }: { events: TrackingEvent[] }) {
  return (
    <ol className="space-y-4">
      {events.map((e, i) => {
        const isLast = i === events.length - 1;
        const Icon = e.status === "exception" ? AlertTriangle : isLast ? Circle : CheckCircle2;
        return (
          <li key={`${e.status}-${i}`} className="flex gap-3">
            <Icon
              className={
                e.status === "exception"
                  ? "h-5 w-5 shrink-0 text-amber-500"
                  : isLast
                    ? "h-5 w-5 shrink-0 text-brand-600"
                    : "h-5 w-5 shrink-0 text-green-600"
              }
            />
            <div>
              <p className="font-medium text-brand-900">{e.label}</p>
              <p className="text-sm text-brand-500">
                {fmt(e.timestamp)}
                {e.location ? ` - ${e.location}` : ""}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
